import { useQuery } from "@tanstack/react-query";
import { SeatClassService } from "../../../../../services/vos/business-tickets/seat-class.service";

const useSeatClass = () => {
  const query = useQuery({
    queryKey: ["seat-class"],
    queryFn: () => SeatClassService.getSeatClassList(),
  });

  return query;
};

export default useSeatClass;
